import { IconLogOut02, IconShuffle01 } from '@pentabd/icons';
import { Avatar, Badge, Dropdown } from '@pentabd/ui';
import { useAuth } from '@hooks/useAuth';

type Props = {
  electionScheduleName: string;
  openElectionModalHandler: () => void;
};

const RightSideNavMenu = ({
  electionScheduleName,
  openElectionModalHandler,
}: Props) => {
  const { signOut } = useAuth();

  return (
    <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center ">
      <div className="me-0 me-sm-5 mb-5 mb-sm-0">
        <Badge
          label={electionScheduleName}
          type="danger"
          size="sm"
          className="text-nowrap w-max"
        />
      </div>
      <div className="align-self-end">
        <Dropdown
          buttonType="customIcon"
          customIcon={
            <Avatar
              imageURL="https://placehold.co/100x100/gray/white/?text=S"
              name="Penta"
              size="sm"
            />
          }
          listItem={[
            {
              name: 'সাইন আউট',
              icon: <IconLogOut02 size="16" />,
              onClick: () => signOut(),
            },
            {
              name: 'নির্বাচন পরিবর্তন করুন',
              icon: <IconShuffle01 size="16" />,
              onClick: () => openElectionModalHandler(),
            },
          ]}
        />
      </div>
    </div>
  );
};

export default RightSideNavMenu;
